import React from 'react';
import './Testimonials.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const fallbackReviews = [
  {
    id: 'fallback-1',
    text: "Ordered a custom birthday cake for my daughter and it was absolutely stunning! The fondant work was so detailed and the cake tasted heavenly. Alka really puts love into every creation.",
    author: 'Priya Sharma',
    profile_photo_url: '',
    rating: 5,
    relative_time_description: '2 weeks ago',
  },
  {
    id: 'fallback-2',
    text: "Best cakes in Pune! We've ordered from Alka's CakeWalk for three anniversaries now and each time the cake exceeds our expectations. Fresh ingredients and amazing flavours.",
    author: 'Rahul Deshmukh',
    profile_photo_url: '',
    rating: 5,
    relative_time_description: 'a month ago',
  },
  {
    id: 'fallback-3',
    text: "The chocolate truffle cake was divine! Super moist and rich. Delivery was on time and the packaging was perfect. Highly recommend for any celebration!",
    author: 'Sneha Kulkarni',
    profile_photo_url: '',
    rating: 5,
    relative_time_description: '3 weeks ago',
  },
  {
    id: 'fallback-4',
    text: "Ordered cupcakes for an office party and everyone loved them. Beautiful presentation and great taste. Will definitely order again!",
    author: 'Amit Patil',
    profile_photo_url: '',
    rating: 4,
    relative_time_description: '2 months ago',
  },
];

const Testimonials = () => {
  const [reviews, setReviews] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let isMounted = true;
    const fetchReviews = async () => {
      try {
        const res = await fetch(`${API_BASE}/reviews`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        const items = data?.reviews || [];
        if (isMounted && items.length > 0) setReviews(items);
      } catch (e) {
        console.warn('Reviews API unavailable, using fallback reviews.');
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    fetchReviews();
    return () => { isMounted = false; };
  }, []);

  const list = reviews.length > 0 ? reviews : fallbackReviews;

  const renderStars = (rating = 5) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`fa${i <= Math.round(rating) ? 's' : 'r'} fa-star`}
          style={{ color: 'var(--accent-color)', marginRight: 2 }}
          aria-hidden="true"
        />
      );
    }
    return <span className="review-stars" aria-label={`Rating ${rating} out of 5`}>{stars}</span>;
  };

  return (
    <section className="testimonials-section">
      <div className="section-header">
        <h2 className="section-title">Sweet Words From Our Clients</h2>
        <p className="section-subtitle">We love making our clients happy. Here's what they have to say about their CakeWalk experience.</p>
      </div>
      {loading ? (
        <div className="testimonials-container"><p>Loading reviews...</p></div>
      ) : (
        <>
          <div className="testimonials-container">
            {list.map((r) => (
              <div key={r.id} className="testimonial-card">
                <p className="testimonial-quote">{r.text}</p>
                <div className="testimonial-author">
                  {r.profile_photo_url ? (
                    <img 
                      src={r.profile_photo_url} 
                      alt={r.author} 
                      className="author-avatar" 
                      onError={(e) => {
                        e.currentTarget.src = 'https://picsum.photos/seed/avatar/60/60.jpg';
                        e.currentTarget.onerror = null;
                      }}
                    />
                  ) : (
                    <img 
                      src='https://picsum.photos/seed/avatar/60/60.jpg'
                      alt={r.author} 
                      className="author-avatar" 
                    />
                  )}
                  <div className="author-info">
                    <span className="author-name">{r.author}</span>
                    <span className="author-handle">{r.relative_time_description || ''}</span>
                    <div className="author-rating">{renderStars(r.rating)}</div>
                    {r.author_url && (
                      <a 
                        href={r.author_url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="review-link"
                      >
                        <i className="fab fa-google" style={{ marginRight: 4, fontSize: 12 }}></i>
                        View on Google
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="google-reviews-attribution">
            <a
              href="https://www.google.com/maps/search/Alka's+CakeWalk+Pune"
              target="_blank"
              rel="noopener noreferrer"
              className="google-reviews-link"
            >
              <i className="fab fa-google" style={{ marginRight: 6 }}></i>
              See all reviews on Google
            </a>
          </div>
        </>
      )}
    </section>
  );
};

export default Testimonials;
